import apiUrl from '../../../constants'
import axios from 'axios'
import iptrackerdetails from '../../../iptrackerdetails'
import Paginate from 'vuejs-paginate'
import CryptoJS from 'crypto-js';
import {
    Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';

export default {
    name: 'employeecategory',
    components: {
        Paginate,
        VueElementLoading
    },
    data: function() {
        return {
            modalShow: false,
            addEmpCategoryModal: false,
            empcategoryaction: '',
            listEmpCategoryData: [],
            changestatus: '',
            props: [],
            pageno: 0,
            pagecount: 0,
            EmpCategoryName: '',
            iptrackData:'',
            searchEmpCategoryName: '',
            EmpCategoryId: '',
            isLoading: false,
            resultCount: '',
            isActive: '',
            count: 0
        }
    },
    mounted() {
        var userdetailEncrypt = window.localStorage.getItem('userdetail')
        var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
        var plaintext = bytes.toString(CryptoJS.enc.Utf8);
        var userdetail = JSON.parse(plaintext);
        this.iptrackData = userdetail
        this.localuserid = userdetail.userid;
        this.localusername = userdetail.username;
        this.getEmpCategoryData();
    },
    methods: {
        addEmpCategory() {
            this.EmpCategoryName = '',
            this.EmpCategoryId = '',
            this.isActive = true,
            this.empcategoryaction = 'add',
            this.addEmpCategoryModal = true,
            this.$validator.reset();
            this.errors.clear();
        },
        closeEmpCategoryModal() {
            $("#employeecategoryform").trigger("reset");
            this.addEmpCategoryModal = false,
            this.$validator.reset();
            this.errors.clear();
        },
        closeStatusEmpCategoryModal() {
            this.modalShow = false
        },
        searchEmpCategoryData(){
          this.pageno = 0;
          this.$refs.paginate.selected = 0;
          this.getEmpCategoryData();
        },
        getEmpCategoryData() {
            var userToken = window.localStorage.getItem('userToken')
            var myStr = userToken.replace(/"/g, '');

            this.input = ({
                offset: this.pageno,
                limit: 10,
                EmpCategoryName: this.searchEmpCategoryName
            })
            this.isLoading = true;

            axios({
                    method: 'POST',
                    'url': apiUrl.api_url + 'empcategorymaster',
                    'data': this.input,
                    headers: {
                        'Authorization': 'Bearer ' + myStr
                    }
                })
                .then(result => {
                    this.listEmpCategoryData = result.data.rows;
                    this.isLoading = false;
                    let totalRows = result.data.count
                    this.resultCount = result.data.count
                    if (totalRows < 10) {
                        this.pagecount = 1
                    } else {
                        this.pagecount = Math.ceil(totalRows / 10)
                    }
                }, error => {
                    console.error(error)
                })
        },

        saveEmpCategory(event) {
          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          let reqpayload = ({
              EmpCategoryName: this.EmpCategoryName,
              isActive: this.isActive,
              CreatedBy: this.localuserid
          })
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'submitEmpCategoryData',
              'data': reqpayload,
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          })
          .then((response) => {
              if (response.data.errorCode == 0) {
                  this.$alertify.success(response.data.msg);
                  this.addEmpCategoryModal = false;
                  event.target.reset();
                  this.resetForm();
              } else if (response.data.errorCode == -1) {
                  this.$alertify.error(response.data.msg)
              }
              iptrackerdetails.checkUserIP(this.iptrackData,'Save Employee category',this.$route.path,reqpayload,response.data);

          })
          .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
          });
        },

        getEmpCategoryRowData(data) {
            this.$validator.reset();
            this.errors.clear();
            this.empcategoryaction = 'edit';
            this.addEmpCategoryModal = true;
            this.EmpCategoryName = data.EmpCategoryName;
            this.EmpCategoryId = data.EmpCategoryId;
            this.isActive = data.isActive;
        },

        editEmpCategory(event) {

          var userToken = window.localStorage.getItem('userToken')
          var myStr = userToken.replace(/"/g, '');

          let reqpayload = ({
              EmpCategoryId: this.EmpCategoryId,
              EmpCategoryName: this.EmpCategoryName,
              isActive: this.isActive,
              LastModifiedBy: this.localuserid
          })
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'updateEmpCategory',
              'data': reqpayload,
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          })
          .then((response) => {
              if (response.data.errorCode == 0) {
                  this.$alertify.success(response.data.msg);
                  this.addEmpCategoryModal = false;
                  event.target.reset();
                  this.resetForm();
              } else if (response.data.errorCode == -1) {
                  this.$alertify.error(response.data.msg)
              }
              iptrackerdetails.checkUserIP(this.iptrackData,'Update Employee category',this.$route.path,reqpayload,response.data);

          })
          .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
          })
        },

        //to get pagination
        getPaginationData(pageNum) {
            this.pageno = (pageNum - 1) * 10
            this.getEmpCategoryData()
        },

        //to get target id in active/inactive modal
        getStatusRowData(data) {
            this.Statusaction   = 'add'
            this.modalShow      = true
            this.EmpCategoryId  = data.EmpCategoryId
            this.isActive       = data.isActive
            if (data.isActive === 'true') {
                this.changestatus = 'De-Activate'
            } else {
                this.changestatus = 'Activate'
            }
        },

        //for active/inactive modal
        changeEmpCategoryStatus() {
          var userToken = window.localStorage.getItem('userToken')
          var myStr     = userToken.replace(/"/g, '');

        let reqpayload = ({
            'EmpCategoryId': this.EmpCategoryId,
            'isActive': this.isActive
        })
          axios({
              method: 'POST',
              'url': apiUrl.api_url + 'updateEmpCategoryStatus',
              'data': reqpayload,
              headers: {
                  'Authorization': 'Bearer ' + myStr
              }
          })
          .then((response) => {
              if (response.data.errorCode == 0) {
                  this.$alertify.success(response.data.msg);
                  this.addEmpCategoryModal = false
                  this.getEmpCategoryData()
              } else if (response.data.errorCode == -1) {
                  this.$alertify.error(response.data.msg)
              }
              iptrackerdetails.checkUserIP(this.iptrackData,'Update EmpCategory Status',this.$route.path,reqpayload,response.data);

          })
          .catch((httpException) => {
              console.error('exception is:::::::::', httpException)
          })
        },

        onSubmit: function(event) {
          this.$validator.validateAll().then((result) => {
            if(result){
              //console.log('form is valid', this.model);
              if(this.EmpCategoryId!=undefined && this.EmpCategoryId!=""){
                this.editEmpCategory(event);
              }else{
                this.saveEmpCategory(event);
              }
            }
          }).catch(() => {
            console.log('errors exist', this.errors)
          });
        },

        resetSearch(){
          this.searchEmpCategoryName = '';
          this.pageno = 0;
          this.$refs.paginate.selected = 0;
          this.getEmpCategoryData();
        },

        resetForm() {
            this.EmpCategoryId = '';
            this.EmpCategoryName = '';
            this.isActive = '';
            this.empcategoryaction = 'add';
            this.$validator.reset();
            this.errors.clear();
            this.getEmpCategoryData();
        },
    }
}



// WEBPACK FOOTER //
// ./src/views/components/employeecategory/employeecategory.component.js